<template>
  <div class="inpBox">
    <div class="detailsTitle" >
       <h4>提单发布</h4>
       <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
   <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="110px" size="mini">
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-envelope iconFont" aria-hidden="true"></i>收发货信息</span>
        </h4>
        <div>
            <el-form-item  class="is-required" label="发货单位:" prop="deliverCompany">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="20" :readonly="true"  v-model="goodform.deliverCompany"></el-input>
          </el-form-item>
          <el-form-item    class="is-required" label="发货人:" prop="deliverPerson">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="10" :readonly="true"  v-model="goodform.deliverPerson"></el-input>
          </el-form-item>
          <el-form-item label="发货人电话:" class="is-required" prop="deliverPhone">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="11" :readonly="true"  type="tel" v-model="goodform.deliverPhone"></el-input>
          </el-form-item>
          <el-form-item  label="发货地址:" prop="deliverAddress" class="diqu1">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="11" :readonly="true"  v-model="goodform.deliverAddress"></el-input>
          </el-form-item>
           <el-form-item >
              <el-button type="text"  @click="addxzdzFn(2)"><i class="fa fa-address-book-o iconFont" aria-hidden="true"></i>使用发货地址簿</el-button>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="收货单位:" prop="receivingCompany">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="20" :readonly="true"  v-model="goodform.receivingCompany"></el-input>
        </el-form-item>
        <el-form-item  label="收货人:" prop="receivingPerson">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="10" :readonly="true"  v-model="goodform.receivingPerson"></el-input>
        </el-form-item>
        <el-form-item label="收货人电话:" prop="receivingPhone">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="11" :readonly="true"  type="tel" v-model="goodform.receivingPhone"></el-input>
        </el-form-item>
          <el-form-item  label="收货地址:" prop="receivingAddress" class="diqu1">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="11" :readonly="true"  v-model="goodform.receivingAddress"></el-input>
        </el-form-item>
        <el-form-item >
              <el-button type="text"  @click="addxzdzFn(1)"><i class="fa fa-address-book-o iconFont" aria-hidden="true"></i>使用收货地址簿</el-button>
          </el-form-item>
        </div>
      </div>
       <hr>
      <div class="addressBox">
         <h4 class="title">
          <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>承运信息</span>
          <el-button type="primary" style="margin-left:14px"     @click="zhipaiFn">指派</el-button>
        </h4>
      <div>
           <!-- <el-form-item label="委托平台:" prop="commissionPlatform" class="ziti" >
            <template >
              <el-radio-group v-model="goodform.commissionPlatform"  @change="commissionPlatformChange">
                <el-radio :label="1" >是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </template>
          </el-form-item> -->
           <div v-if="goodform.carriageType==1">
             <el-form-item label="承运车队:" prop="carriageName">
                <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="goodform.carriageName"></el-input>
             </el-form-item>
           </div>
           <div v-if="goodform.carriageType==2">
             <el-form-item label="承运司机:" prop="carriageName">
                <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="goodform.carriageName"></el-input>
             </el-form-item>
             <el-form-item label="身份证号:" prop="carriageCustomerTaxId">
                <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="goodform.carriageCustomerTaxId"></el-input>
             </el-form-item>
              <el-form-item label="车牌号:" prop="vhcNo">
                <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="goodform.vhcNo"></el-input>
             </el-form-item>
           </div>
            <div v-if="goodform.carriageType==3">
             <el-form-item label="车队长名称:" prop="carriageName">
                <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="goodform.carriageName"></el-input>
             </el-form-item>
           </div>
        </div>
      </div>
      <hr>
      <div class="addressBox">
         <h4 class="title">
          <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
        </h4>
        <div>
       <div class="searchBtnBox">
          <el-form-item>
           <p class="margin0">货物重量：<span class="red">{{goodform.weight}}</span>吨&nbsp; &nbsp; 合计件数：<span class="red">{{goodList.length}}</span>件</p>
          </el-form-item>
       </div>
       <div style="margin-bottom:20px">
          <el-table :data="goodList"  ref="table"   bordersize="mini"  @row-click="handleRowClick" class="table"  border>
          <el-table-column type="selection" width="55" ></el-table-column>
              <el-table-column type="index" label="序号"></el-table-column>
              <el-table-column property="cargoBarcode"  width="160" label="捆包号"></el-table-column>
              <el-table-column property="productTypeName" label="货物类型"></el-table-column>
          <el-table-column property="productName" width="100" :show-overflow-tooltip="true" label="品名"></el-table-column>
          <el-table-column property="model" width="120" :show-overflow-tooltip="true" label="材质"></el-table-column>
          <el-table-column property="specification" width="120" :show-overflow-tooltip="true" label="规格"></el-table-column>
          <el-table-column property="weight" label="重量"></el-table-column>
          <el-table-column property="contractNumber" width="120" :show-overflow-tooltip="true" label="合同号"></el-table-column>
          <el-table-column property="agreementNumber" width="120" :show-overflow-tooltip="true" label="合约号"></el-table-column>
          <el-table-column property="cargoLocation" width="150" :show-overflow-tooltip="true" label="货位"></el-table-column>
          <el-table-column property="organizationName" width="120" :show-overflow-tooltip="true" label="所在仓库"></el-table-column>
            <el-table-column property="enterTime" width="160" :formatter="dateTimeFormat" label="入库时间"></el-table-column>
          </el-table>
       </div>
      <el-form-item label="货物类型:" class="jiage" prop="productType">
        <el-select  v-model="goodform.productType"  value-key="productId"  placeholder="请选择">
          <el-option v-for="item in productTypes" :label="item.name" :value="item" :key="item.productId"></el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="货源量:"  prop="weight" class="jiage">
        <el-input  placeholder="" v-number-input.float="3"   class="disabled" :readonly="true"  v-model="goodform.weight" key="1" ></el-input><span class="danwei">吨</span>
      </el-form-item>
      <!-- <el-form-item label="扫码装车:" prop="scanLoading " class="ziti" v-if="goodform.commissionPlatform==2">
        <template >
          <el-radio-group v-model="goodform.scanLoading ">
            <el-radio :label="1" >是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </template>
      </el-form-item> -->
        </div>
      </div>
      <hr>
      <!-- 费用相关 -->
      <costCompute :goodform="goodform" ></costCompute>
      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>其他信息</span>
        </h4>
        <div>
          <div>

              <el-form-item label="已购货险:" prop="isInsurance" class="ziti"  >
              <template >
                <el-radio-group v-model="goodform.isInsurance">
                  <el-radio :label="1" >是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
            <div style="display: inline-block;" v-if="goodform.isInsurance==1">
              <el-form-item label="保险信息:" prop="insuranceInfo"   >
                <el-input  placeholder=""    maxlength="50" v-model="goodform.insuranceInfo"  ></el-input>
              </el-form-item>
              <el-form-item label="保险单号:" prop="insuranceNo" >
                <el-input  placeholder=""    maxlength="30" v-model="goodform.insuranceNo"  ></el-input>
              </el-form-item>
              <el-form-item label="保险公司名称:" prop="insuranceCompany" >
                <el-input  placeholder=""   maxlength="20"  v-model="goodform.insuranceCompany"  ></el-input>
              </el-form-item>
            </div>
          </div>
      <el-form-item label="最晚到场日期:" prop="hopeReceivingDate">
            <el-date-picker
              v-model="goodform.hopeReceivingDate"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="datetime"
                placeholder="选择日期时间"
                 :picker-options="pickerOptions"
            ></el-date-picker>
      </el-form-item>
      <el-form-item label="备注:" class="remark" prop="remark" >
        <el-input  placeholder=""  maxlength="500" v-model="goodform.remark"></el-input>
      </el-form-item>
      <div class="imgBox">
        <!-- <ul><li></li></ul>
        <input type="file" accept="image/*"  @change="getFile($event)"> -->
       <el-upload
        action="/stock/sBill/addFiles"
        ref="upload"
        :headers="header"
        :auto-upload=false
        :multiple=true
        :on-change="imgPreview"
        list-type="picture-card"
        accept="image/*"
        :limit="20"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove" :class="[isAdd?'hidden':'']">

      </el-upload>
      <span style="font-size:12px">最多上次5张，支持jpg、png格式图片</span>
      <el-dialog  title="图片展示" :visible.sync="dialogVisible" center>
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
      </div>
      </div>
      </div>
   </el-form>
   <div class="footerBtn">
      <!-- <el-button type="primary" class="bigBtn"  btnCode="004P001B001"  @click="saveFn('goodform',1001)">暂存</el-button> -->
      <el-button type="primary" class="bigBtn"  btnCode="004P001B000"  @click="saveFn('goodform',1002)">提交</el-button>
    </div>
    <!-- 选择地址 -->
       <selectAddress :type= "addressType"  v-if="dialogXzdz"  @handleCurrentChange="handleCurrentChange" @destroy="destroy"></selectAddress>
    <!-- 指派组件 -->
      <assign assignType='3'   v-if="assignFalg" @selectCar="selectCar" @selectFleet="selectFleet" @destroy="destroy"></assign>
  </div>
</template>

<script>
import { dropDownList, pushOrder, goodsDetail } from '@/api/soc-stock'
import { compressImage } from '@/utils/compressImage'
import assign from '@/components/networkFreight/assign.vue'
import selectAddress from '@/components/networkFreight/selectAddress.vue'
import costCompute from '@/components/networkFreight/costCompute.vue'
import store from '@/store'
import { dateTimeFormat } from '@/utils/util'
export default {
  components: {
    assign,
    selectAddress,
    costCompute
  },
  data () {
    let token = store.getUser().access_token
    var id = this.$route.query.id
    return {
      dateTimeFormat: dateTimeFormat,
      assignFalg: false,
      imgList: [],
      dialogImageUrl: '',
      header: { Authorization: 'Bearer ' + token },
      dialogVisible: false,
      isAdd: false,
      freight: 0.00,
      productTypes: [
      ],
      danwei: [
        { val: '吨', name: '吨' },
        { val: '件', name: '件' },
        { val: '方', name: '方' }
      ],
      jsfangshi: [
        { val: 1, name: '电汇' },
        { val: 2, name: '现金' },
        { val: 3, name: '其他' }
      ],
      dialogAddress: false,
      types: [
        { name: '收货地址', id: 1 },
        { name: '发货地址', id: 2 }
      ],
      addFrom: {},
      rules: {
        type: [
          { required: true, message: '请选择地址类型', trigger: 'blur' }
        ],
        areaCode: [
          { required: true, message: '请选择省市县', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        weight: [
          { required: true, message: '请输入货源量', trigger: 'blur' },
          this.rule.weight
        ],
        hopeReceivingDate: [
          { required: true, message: '请选择最晚到场日期', trigger: 'blur' }
        ],
        isInsurance: [
          { required: true, message: '是否已购货险', trigger: 'blur' }
        ],
        insuranceInfo: [
          { required: true, message: '请输入保险信息', trigger: 'blur' }
        ],
        insuranceNo: [
          { required: true, message: '请输入保险单号', trigger: 'blur' }
        ],
        insuranceCompany: [
          { required: true, message: '请输入保险公司名称', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        receivingCompany: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ],
        receivingPerson: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ],
        unitPrice: [
          { required: true, message: '请输入单价或包干价', trigger: 'blur' },
          this.rule.price
        ],
        pricingMethod: [
          { required: true, message: '请选择计价方式', trigger: 'blur' }
        ],
        receivingPhone: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
          // { pattern: /^[1]([3-9])[0-9]{9}$/, message: '请输入正确得电话号码' }
        ],
        deliverAddress: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ],
        receivingAddress: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ],
        deliverCompany: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ],
        deliverPerson: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ],
        deliverPhone: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ]
      },
      dialogXzdz: false,
      addressType: 1,
      goodform: {
        id: id,
        productVolume: 0,
        fatePrice: 0,
        storagePrice: '',
        price: '',
        pricingMethod: '',
        taxation: 0,
        allP: 0,
        unitMeasurement: '吨',
        commissionPlatform: 2,
        isInsurance: 2,
        orderSource: 4
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      goodList: [] // 货物列表
    }
  },
  created () {
    goodsDetail({ id: this.goodform.id }).then(res => {
      this.goodList = res.goodsList
      this.billData = res.sBill
      this.$set(this.goodform, 'weight', res.sBill.allWeight)
    })
    dropDownList().then(res => {
      this.productTypes = res
      this.productTypes.unshift({ productId: '', name: '请选择' })
    })
  },
  watch: {

  },
  methods: {
    // 指派
    zhipaiFn () {
      this.assignFalg = true
    },
    selectFleet (row) {
      for (var item in row) {
        if (item == 'fleetId') {
          this.$set(this.goodform, 'carriageCode', row[item])
        } else if (item == 'CustomerTaxId') {
          this.$set(this.goodform, 'carriageCustomerTaxId', row[item])
        } else if (item == 'fleetName') {
          this.$set(this.goodform, 'carriageName', row[item])
        } else if (item == 'mobile') {
          this.$set(this.goodform, 'carriageTelephone', row[item])
        } else {
          this.$set(this.goodform, item, row[item])
        }
      }
      this.$set(this.goodform, 'vhcId', '')
      this.$set(this.goodform, 'vhcNo', '')
      this.$set(this.goodform, 'vhcNoColor', '')
      this.$set(this.goodform, 'businessLicenseNo', '')
      this.assignFalg = false
    },
    selectCar (row) {
      for (var item in row) {
        if (item == 'driverId') {
          this.$set(this.goodform, 'carriageCode', row[item])
        } else if (item == 'identityNo') {
          this.$set(this.goodform, 'carriageCustomerTaxId', row[item])
        } else if (item == 'driverName') {
          this.$set(this.goodform, 'carriageName', row[item])
        } else if (item == 'mobile') {
          this.$set(this.goodform, 'carriageTelephone', row[item])
        } else {
          this.$set(this.goodform, item, row[item])
        }
      }
      this.assignFalg = false
    },
    destroy () {
      this.assignFalg = false
      this.dialogXzdz = false
    },
    // 是否委托平台切换
    commissionPlatformChange () {
      if (this.goodform.commissionPlatform == 1) {
        this.goodform.carriageType = ''
        this.goodform.carriageCode = ''
        this.goodform.carriageCustomerTaxId = ''
        this.goodform.carriageTelephone = ''
        this.goodform.carriageName = ''
        this.goodform.vhcId = ''
        this.goodform.vhcNo = ''
        this.goodform.vhcNoColor = ''
        this.goodform.businessLicenseNo = ''
        this.goodform.scanLoading = 2
      }
    },
    // 单位切换
    danweiChange () {
      this.$set(this.goodform, 'weight', '')
    },
    getFile (e) {
      this.file = e.target.files[0]
    },
    saveFn (formName, n) {
      console.log(this.goodform)
      let imgfile = new FormData()
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.goodform.carriageName || this.goodform.commissionPlatform == 1) {
            this.goodform.orderStatus = n
            if (this.goodform.productType) {
              this.goodform.productTypeId = this.goodform.productType.productId
              this.goodform.productTypeName = this.goodform.productType.name
              this.goodform.productTypeCode = this.goodform.productType.productTypeCode
            }
            if (this.goodform.isInsurance == 2) {
              this.goodform.insuranceInfo = ''
              this.goodform.insuranceNo = ''
              this.goodform.insuranceCompany = ''
            }

            imgfile.append('param', JSON.stringify(this.goodform))

            if (this.imgList.length > 0) {
              for (var i = 0; i < this.imgList.length; i++) {
                let a = i
                compressImage(this.imgList[i].url, this.imgList[i].raw, {
                  width: 1000
                }).then(result => {
                  imgfile.append('files', result)// result即为压缩后的结果
                  if (a == that.imgList.length - 1) {
                    saveFN()
                  }
                })
              }
            } else {
              saveFN()
            }
          } else {
            this.$alert('请指派承运方', '系统提示')
          }
        }
      })

      function saveFN () {
        that.$refs[formName].validate((valid) => {
          if (valid) {
            const loading = that.$loading({
              lock: true,
              text: '正在处理...'
            })
            pushOrder(imgfile).then(res => {
              loading.close()
              that.$router.push({ name: 'orderManage' })
            }).catch(error => {
              that.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        })
      }
    },
    // 图片上传
    handleRemove (file, fileList) {
      console.log(file, fileList)
      this.imgList = fileList
      if (fileList.length < 5) {
        this.isAdd = false
      }
    },

    imgPreview (file, fileList) {
      console.log(file, fileList)
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.png)$/
      if (regex.test(fileName.toLowerCase())) {
        this.imgList = fileList
        if (fileList.length < 5) {
          this.isAdd = false
        } else {
          this.isAdd = true
        }
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图', '系统提示')
        return false
      }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        status: 0,
        organizationId: this.goodList[0].organizationId,
        instockDate: null
      }
    },
    // 选择地址
    addxzdzFn (n) {
      this.addressType = n
      this.dialogXzdz = true
    },
    closeDialog () {
      this.$refs.addTable.clearSelection()
      this.searchFrom = {
        pageNo: 1,
        status: 0,
        organizationId: this.goodList[0].organizationId,
        instockDate: null,
        pageSize: 50
      }
    },
    handleCurrentChange (val) {
      this.currentRow = val
      this.dialogXzdz = false
      if (this.addressType == 1) {
        this.$set(this.goodform, 'receivingCompany', this.currentRow.company)
        this.$set(this.goodform, 'receivingPerson', this.currentRow.person)
        this.$set(this.goodform, 'receivingPhone', this.currentRow.phone)
        this.$set(this.goodform, 'receivingAddress', this.currentRow.name)
        this.goodform.receivingProvinceCode = this.currentRow.provinceCode
        this.goodform.receivingCityCode = this.currentRow.cityCode
        this.goodform.receivingAreaCode = this.currentRow.areaCode
        this.goodform.receivingProvinceName = this.currentRow.provinceName
        this.goodform.receivingCityName = this.currentRow.cityName
        this.goodform.receivingAreaName = this.currentRow.areaName
        this.goodform.receivingAddressId = this.currentRow.id
        this.goodform.receivingLongitude = this.currentRow.longitude
        this.goodform.receivingLatitude = this.currentRow.latitude
      } else {
        this.$set(this.goodform, 'deliverCompany', this.currentRow.company)
        this.$set(this.goodform, 'deliverPerson', this.currentRow.person)
        this.$set(this.goodform, 'deliverPhone', this.currentRow.phone)
        this.$set(this.goodform, 'deliverAddress', this.currentRow.name)
        this.goodform.deliverProvinceCode = this.currentRow.provinceCode
        this.goodform.deliverCityCode = this.currentRow.cityCode
        this.goodform.deliverAreaCode = this.currentRow.areaCode
        this.goodform.deliverProvinceName = this.currentRow.provinceName
        this.goodform.deliverCityName = this.currentRow.cityName
        this.goodform.deliverAreaName = this.currentRow.areaName
        this.goodform.deliverAddressId = this.currentRow.id
        this.goodform.deliverLongitude = this.currentRow.longitude
        this.goodform.deliverLatitude = this.currentRow.latitude
      }
      this.$refs.goodform.clearValidate()
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }

  }
}
</script>

<style scoped lang='less'>

.imgBox{
  margin: 22px 10px;
}

.hidden /deep/.el-upload--picture-card{
  display: none;
}
.danweiBox{
  /deep/.el-input{
    width: auto;
  }
  /deep/.el-select{
    width: 60px;
    .el-input__inner{
    width: 60px;
  }
  }
}

</style>
